import * as React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useRouteMatch } from "react-router-dom";
import { IHomeHeaderMenu } from "../../models/interfaces/home-header-menu.interface";
import HomeHeaderMegaMenu from "../HomeHeaderMegaMenu";
import "./HomeHeaderMenu.scss";

type HomeHeaderMenuProps = {
  menu: IHomeHeaderMenu
}

const HomeHeaderMenu = (props: HomeHeaderMenuProps) => {

  const { menu } = props;
  const match = useRouteMatch();
  const { t } = useTranslation();
  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/icons/${imgName}.png`)?.default;
  };

  return (
    <div className="home-header-menu">
      <NavLink
        to={match.url + menu.routeUrl}
        className="box-border flex flex-col items-center justify-center px-2 text-gray-700 border-b-4 border-white border-opacity-0 min-w-20 hover:border-opacity-100 hover:border-gray-300 h-14 hover:bg-gray-50"
        activeClassName="bg-gray-50 border-blue-700 border-opacity-100 hover:border-blue-700"
      >
        <img className="h-4 my-1" src={IMG(menu.icon)} alt=""></img>
        <div className="text-xs">{t(menu.labelKey)}</div>
      </NavLink>

      <div className="w-auto mega-menu">
        <HomeHeaderMegaMenu megaMenu={menu.megaMenu} parentRouteUrl={menu.routeUrl}></HomeHeaderMegaMenu>
      </div>
    </div>
  );
};

export default HomeHeaderMenu;
